import localize from '@/filters/localize';

// Short relative time for the notifications dropdown ("8 min ago", "1 h ago",
// "Yesterday", "2 days ago"). Falls back to the plain date once it's more than a week
// old, since "12 days ago" reads worse than a real date at that point.
export default function relativeTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString.replace(' ', 'T'));
  if (isNaN(date.getTime())) return dateString;

  const diffMs = Date.now() - date.getTime();
  const diffMinutes = Math.floor(diffMs / 60000);

  if (diffMinutes < 1) return localize('justNow');
  if (diffMinutes < 60) return `${diffMinutes} ${localize('minAgo')}`;

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) return `${diffHours} ${localize('hAgo')}`;

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays === 1) return localize('yesterday');
  if (diffDays < 7) return `${diffDays} ${localize('daysAgo')}`;

  // Older than a week: plain local-time YYYY-MM-DD, built from the already-parsed `date`
  // (not dateString.split(' ')[0], which only works for the legacy space-separated format
  // and returns the whole raw string for the API's ISO 8601 timestamps), and not
  // toISOString(), which would shift a midnight-local date to the wrong day in UTC.
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
